var render = function render(_c,_vm){return _c('div',{class:_vm.$style.container},[_c('div',{class:_vm.$style.title},[_vm._v(_vm._s(_vm.props.title))]),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }